module.exports = __webpack_public_path__ + "static/img/fa88b8e7c2f70a9867a4a0ed9cef29f.088f8e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fa88b8e7c2f70a9867a4a0ed9cef29f.jpg
// module id = WH3d
// module chunks = 0